/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import Skeleton from './skeleton';

const LoadingSkeleton = (): JSX.Element => (
  <div>
    <Skeleton
      width="72px"
      height="72px"
      css={css`
        margin-left: auto;
        margin-right: auto;
      `}
    />
    <Skeleton
      width="40%"
      height="17px"
      css={css`
        margin: 32px auto 40px;
      `}
    />
    <Skeleton width="70%" height="30px" />
    <Skeleton
      width="100%"
      height="42px"
      css={css`
        margin: 25px 0;
      `}
    />
    <Skeleton width="30%" height="21px" />
    <Skeleton
      width="100%"
      height="40px"
      css={css`
        margin-top: 4px;
      `}
    />
    <Skeleton
      width="30%"
      height="21px"
      css={css`
        margin: 24px 0 4px;
      `}
    />
    <Skeleton width="100%" height="40px" />
    <Skeleton
      width="100%"
      height="40px"
      css={css`
        margin: 24px 0 0;
      `}
    />
  </div>
);

export default LoadingSkeleton;
